/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Organization_Brand_Scope_Of_SupplierInputs */

const en_error_organization_brand_scope_of_supplier = /** @type {(inputs: Error_Organization_Brand_Scope_Of_SupplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A user of a supplier would act for a brand, and see the purchase orders of the brand's other suppliers: take that scope away from the user first.`)
};

/**
* | output |
* | --- |
* | "A user of a supplier would act for a brand, and see the purchase orders of the brand's other suppliers: take that scope away from the user first." |
*
* @param {Error_Organization_Brand_Scope_Of_SupplierInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_organization_brand_scope_of_supplier = /** @type {((inputs?: Error_Organization_Brand_Scope_Of_SupplierInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Organization_Brand_Scope_Of_SupplierInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_organization_brand_scope_of_supplier(inputs)
});